import * as React from 'react';

function IconActionTrashMedium(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M16 8V7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7V8H4V10H20V8H16ZM10 8V7C10 6.46957 10.2107 5.96086 10.5858 5.58579C10.9609 5.21071 11.4696 5 12 5C12.5304 5 13.0391 5.21071 13.4142 5.58579C13.7893 5.96086 14 6.46957 14 7V8H10Z"
        fill="currentColor"
      />
      <path d="M7 21H17L18 12H6L7 21Z" fill="currentColor" />
    </svg>
  );
}

export default IconActionTrashMedium;
